module.exports = __webpack_public_path__ + "95d242295fa67cb91317a44215ef34cb.MP3";